import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
const QUERY = '(prefers-reduced-motion: no-preference)';
export function usePrefersReducedMotion() {
  const $ = _c(2);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mediaQueryList = window.matchMedia(QUERY);
      setPrefersReducedMotion(!window.matchMedia(QUERY).matches);
      const listener = event => {
        setPrefersReducedMotion(!event.matches);
      };
      mediaQueryList.addEventListener("change", listener);
      return () => {
        mediaQueryList.removeEventListener("change", listener);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return prefersReducedMotion;
}